import { faStar } from "@jewlr/pro-regular-svg-icons/faStar"
import { faStar as solidStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalfAlt as solidStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalfAlt"
import PropTypes from "prop-types"
import { useMemo } from "react"
import { useSelector } from "react-redux"

import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { roundToHalf } from "helpers/round-to-half"
import { cn } from "styles/utils"

const Ratings = ({ handleClick }) => {
  const productReviews = useSelector((state) => state.wizard.productReviews)
  const wizardLoading = useSelector((state) => state.wizard.loading)

  const displayReview = productReviews?.average_rating >= 4

  const starArray = useMemo(() => {
    const averageRating = displayReview
      ? roundToHalf(productReviews.average_rating, 0.5)
      : 0

    return Array.from({ length: 5 }, (_, i) => {
      const starValue = i + 1
      let icon = faStar

      if (!displayReview || starValue <= averageRating) {
        icon = solidStar
      } else if (starValue <= averageRating + 0.5) {
        icon = solidStarHalf
      }

      return (
        <FontAwesomeIcon
          className={cn(
            "text-rating text-12 mr-2",
            !displayReview && "text-grey-300"
          )}
          icon={icon}
          key={starValue}
        />
      )
    })
  }, [displayReview])

  if (wizardLoading || !productReviews) return null

  return (
    <Button
      aria-label={`${displayReview ? `Rated ${productReviews.average_rating.toFixed(1)} out of 5 from ${productReviews.count} reviews` : "Write a Review"}`}
      className="text-14 shrink-0 font-semibold"
      data-cy="product-rating"
      onClick={handleClick}
      underline={!displayReview}
    >
      {starArray}
      <span className="ml-8 text-black">
        {displayReview ? `${productReviews.count} reviews` : "Write a Review"}
      </span>
    </Button>
  )
}

Ratings.propTypes = {
  handleClick: PropTypes.func,
}

export default Ratings
